export const responsiveAxes = (width, yAxisRef, xAxisRef, formatXAxis) => {
    if (width < 400) {
        yAxisRef
            .selectAll('text')
            .attr('font-size', '9px')
            .attr('transform', 'translate(10, -10)')
            .attr('text-anchor', 'start');
        xAxisRef.selectAll('text').attr('font-size', '9px');
        if (formatXAxis) {
            xAxisRef.selectAll('text').text((d) => {
                let formattedLabel = d;
                formatXAxis.forEach((ele) => {
                    formattedLabel =
                        typeof d === 'string' && ele.length === 2
                            ? formattedLabel.replace(ele[0], ele[1])
                            : formattedLabel;
                });
                return formattedLabel;
            });
        }
    } else {
        xAxisRef
            .selectAll('text')
            .attr('display', 'block')
            .attr('font-size', null);
        xAxisRef.selectAll('.tick').attr('display', 'block');
        yAxisRef
            .selectAll('text')
            .attr('font-size', null)
            .attr('transform', null)
            .attr('text-anchor', null);
    }
};
